module.exports = __webpack_public_path__ + "img/subSmartCanteen.e0a94901.svg";